import { createStore } from 'vuex'
import { persistPlugin } from './plugins/persistPlugin';

import modules from './modules'

const store = createStore({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
  plugins: [persistPlugin],
})

// Token güncellendiğinde route ve menü verileri otomatik temizlenir.
// Bu sayede navigation guard, yeni token'a uygun route'ları API'den tekrar yükler.
// İlgili mutation: auth/SET_TOKEN
store.subscribe((mutation) => {
  if (mutation.type === 'auth/SET_TOKEN' && mutation.payload) {
    store.commit('routeAndMenu/clearRoutes');
    store.commit('routeAndMenu/clearMenus');
  }
});

export default store

